module.exports = __webpack_public_path__ + "assets/apple-share-266fd469eb6e07c09ed3acd49892f3b7.png";